module.exports = __webpack_public_path__ + "static/media/HP_card_grand_dominion.45b62625.jpg";